<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title"><strong>{{getTitleKey() | translate}}</strong></p>
    <button type="button" class="close" (click)="closeDialog(false)" aria-label="Close" [disabled]="creationInProgress">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

    <mat-dialog-content [ngStyle]="{'overflow': formComponent?.hasSelectedTask ? 'auto' : 'visible'}">
      <app-task-record-create-form
        #formComponent
        [data]="data"
        (saving)="creationInProgress = $event"
        (finished)="onFormFinished($event)">
      </app-task-record-create-form>
    </mat-dialog-content>

  <div class="modal-footer justify-content-end">
    <span>
      <button type="button" class="btn btn-outline-primary" (click)="closeDialog(false)" [disabled]="creationInProgress">
        {{'COMMON_BUTTON_CANCEL' | translate}}
      </button>

      <button type="button" class="btn btn-primary ml-1"
              [ladda]="creationInProgress"
              [disabled]="creationInProgress"
              (click)="formComponent.createTaskRecord()">
        {{getSubmitButtonKey() | translate}}
      </button>
    </span>
  </div>
</div>
